const getDictionary = async (file:string) =>
  (await fetch(file)).json();

export default getDictionary;